module.exports = __webpack_public_path__ + "static/media/rebuy.0f260a32.svg";